import React, { useEffect, useState, useRef } from "react";
import "./style.css";

import Spline from "@splinetool/react-spline";

import { GrTechnology } from "react-icons/gr";

export default function Experience() {
  const [isLoaded, setIsLoaded] = useState(false);
  const sectionRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsLoaded(true);
        } else {
          setIsLoaded(false);
        }
      },
      { threshold: 0.2 },
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => {
      if (sectionRef.current) {
        observer.unobserve(sectionRef.current);
      }
    };
  }, []);

  return (
    <div className="experience" ref={sectionRef}>
      {isLoaded && (
        <Spline
          scene="https://prod.spline.design/AXZwiGeimzz1Ghzf/scene.splinecode"
          className="cube-and-circles"
        />
      )}
      <div className="education">
        <h1>Education and Languages</h1>
        <p>
          <GrTechnology className="small-icon" style={{ color: "red" }} />
          <strong>
            Sep 2017 - May 2023<br></br>American University of Armenia(AUA)
            <br></br>BS in Computer Science
          </strong>
          <br></br>
          Studied at American University of Armenia and earned a Bachelor of
          Science (B.S.) degree in Computer Science. Built a strong foundation
          in software development, programming, algorithms, databases, and
          computer systems through academic and practical coursework.
        </p>
        <p>
          <GrTechnology className="small-icon" />
          <strong>
            Sep 2022 - Feb 2023<br></br>TCO Academy - Front-End Development
          </strong>
          <br></br>Completed Front-End Development training at TCO Academy,
          gaining practical experience in HTML, CSS, JavaScript, and React.js.
          Developed responsive web applications and strengthened knowledge of
          modern frontend development practices and UI implementation.
          Successfully earned a certification upon completion of the program.
        </p>
        <p>
          <ul>
            <li>Armenian: Native</li>
            <li>English: Fluent</li>
            <li style={{ marginRight: "52.5px" }}>Russian: Fluent</li>
            <li>French: Beginner</li>
          </ul>
        </p>
      </div>
      <div className="education experience-block">
        <h1>Experience</h1>
        <p>
          <GrTechnology className="small-icon" />
          <strong>
            Jun 2021 - Jun 2022<br></br>MyBrokerSearch - Web Developer
          </strong>
          <br></br>
          In my previous position, I collaborated with US brokers, creating
          marketing materials and designing professional websites. I also
          managed website security, functionality, and integrated IDX software
          for property search capabilities.
        </p>
        <p>
          <GrTechnology className="small-icon" />
          <strong>
            Apr 2023 - Jul 2025<br></br>Team2B - Web Developer
          </strong>
          <br></br>
          In my current role, specialize in creating custom websites for various
          Armenian companies. By leveraging my skills in web development,
          design, and user experience, I deliver visually appealing and
          functional websites for each client.
        </p>
        <p>
          <GrTechnology className="small-icon" />
          <strong>
            Oct 2025 - Jul 2026<br></br>myservice.am - Front-End Developer
          </strong>
          <br></br>Led the redesign and development of a modern, responsive
          company website using React, Tailwind CSS, and Spline, including
          interactive 3D elements and backend API integration. Built and
          improved a partner dashboard while optimizing performance,
          accessibility, and overall user experience across all devices.
        </p>
      </div>
    </div>
  );
}
